import { library } from '@fortawesome/fontawesome-svg-core'

import { faDiscord, faTwitter } from '@awesome.me/kit-428607b2fd/icons/classic/brands'

library.add(faDiscord, faTwitter)
